import {
  Box,
  FlexAnchorProps,
  FormBuilderSection,
  ModalHeader,
  Typo,
  useModal,
} from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React from 'react'
import { FunctionComponent, useCallback } from 'react'

import { TKeyBuilder } from '../../../../infrastructure/internationalisation'
import { InputConfig } from '../../../../state/configuration'
import { WriskTrans } from '../../../organisms/trans'
import useConditions from '../../conditions'
import { isLoopConfig } from '../../config'
import { INPUT_SECTION_CLASS } from '../../options'
import { FormHeader } from '../FormHeader'
import { ReadOnlyInput } from './ReadOnlyInput'
import { ReadOnlyLoop } from './ReadOnlyLoop'

export interface FormReadOnlyProps
  extends Omit<FlexAnchorProps, 'ref' | 'onClick' | 'hidden'> {
  t: TFunction
  tKey: TKeyBuilder
  item: InputConfig
  disabled?: boolean
}

export const FormReadOnly: FunctionComponent<FormReadOnlyProps> = ({
  t,
  tKey,
  item,
  disabled,
  children,
  ...props
}) => {
  const conditions = useConditions()

  const isReadOnly =
    item.readOnly?.conditions.every(conditions) ?? Boolean(item.readOnly?.default)

  const modal = useModal()

  const onClick = useCallback(() => {
    modal.show({
      content: (
        <Box>
          <ModalHeader header={t('defaults.inputs.readonly.header')} />
          <Typo>
            <WriskTrans t={t} i18nKey={'defaults.inputs.readonly.content'} />
          </Typo>
        </Box>
      ),
    })
  }, [modal, t])

  return isReadOnly && !disabled ? (
    <FormBuilderSection id={item.name} width={1} className={INPUT_SECTION_CLASS}>
      <FormHeader input={item} controllerName={item.name} tKey={tKey} t={t} width={1} />
      {isLoopConfig(item) ? (
        <ReadOnlyLoop t={t} tKey={tKey} item={item} onClick={onClick} {...props} />
      ) : (
        <ReadOnlyInput t={t} item={item} onClick={onClick} {...props} />
      )}
    </FormBuilderSection>
  ) : (
    children
  )
}
